// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5bb3cdcf","703":"444a3477","787":"4ea5a485"}[chunkId] + ".chunk.js";
};